import React from "react";
import "../styles/Legal.css";

export default function TermsAndConditions() {
  return (
    <div className="legal-page">
      <h1>Terms & Conditions</h1>

      <p>
        By using Globisun Energies, you agree to comply with and be bound by the following terms and conditions.
      </p>

      <h2>1. User Account</h2>
      <p>You must provide accurate information when creating an account and are responsible for maintaining the confidentiality of your login credentials.</p>

      <h2>2. Acceptable Use</h2>
      <ul>
        <li>Do not use the platform for illegal activities</li>
        <li>Do not upload harmful or malicious content</li>
        <li>Respect the rights and privacy of other users</li>
      </ul>

      <h2>3. Service Availability</h2>
      <p>
        We strive to keep the platform available but cannot guarantee uninterrupted service. We may suspend services for maintenance or upgrades.
      </p>

      <h2>4. Intellectual Property</h2>
      <p>
        All content on this platform, including logos and texts, is the property of Globisun Energies and may not be used without permission.
      </p>

      <h2>5. Termination</h2>
      <p>
        We reserve the right to terminate or restrict access to your account for violations of these terms.
      </p>

      <h2>6. Updates to Terms</h2>
      <p>
        We may update these terms periodically. Continued use of the service means you accept the revised terms.
      </p>

      <h2>7. Contact</h2>
      <p>
        For questions regarding these terms, contact us at:  
        <br />
        <strong>Email:</strong> globisunsolar@gmail.com  
        <br />
        <strong>Phone:</strong> +234 813 129 9300
      </p>
    </div>
  );
}
